import React from "react";
import moment from "moment";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyProcedureDetailsSection({ procedure = {}, sections = {}, context = {} }) {
  const projectDetails = sections.document_project_details && sections.document_project_details.data
    ? sections.document_project_details.data
    : {};
  const procedureApplication = Array.isArray(procedure.sections)
    ? procedure.sections.find((section) => (
      section
      && section.id === "procedure_application"
      && section.data
      && section.data.toggle === 1
    ))
    : null;
  const applicationData = procedureApplication ? procedureApplication.data : {};
  const linkedPlans = Array.isArray(procedure.linked_documents)
    ? procedure.linked_documents.map((plan) => plan && plan.document_number).filter(Boolean).join("; ")
    : "";
  const revision = projectDetails.swms_version
    ? `${projectDetails.swms_version}`.replace(/^v/i, "")
    : "";
  const displayValue = (value) => value || <span>&mdash;</span>;

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.EmergencyProcedureSectionNum}`}>1</span>
        Procedure Details
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Record Identity</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td><span className={styles.PreviewLabel}>Procedure ID</span><span className={styles.PreviewValue}>{displayValue(procedure.document_number || procedure.procedure_id)}</span></td>
              <td><span className={styles.PreviewLabel}>Revision</span><span className={styles.PreviewValue}>{displayValue(revision)}</span></td>
              <td><span className={styles.PreviewLabel}>Status</span><span className={styles.PreviewValue}>Approved</span></td>
              <td><span className={styles.PreviewLabel}>Effective Date</span><span className={styles.PreviewValue}>{projectDetails.issue_date ? moment.utc(projectDetails.issue_date).format("DD/MM/YYYY") : <span>&mdash;</span>}</span></td>
            </tr>
          </tbody>
        </table>
        {procedureApplication ? (
          <>
            <div className={styles.PreviewSectionSubHead}>Procedure Application</div>
            <table className={styles.PreviewTable}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.PreviewLabel}>Scenario</div>
                    <div className={`${styles.PreviewValue} ${styles.PreviewRichText} preview-swms-v3-rich-text`} style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: applicationData.scenario && applicationData.scenario.html ? applicationData.scenario.html : "" }} />
                  </td>
                  <td>
                    <div className={styles.PreviewLabel}>Objective</div>
                    <div className={`${styles.PreviewValue} ${styles.PreviewRichText} preview-swms-v3-rich-text`} style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: applicationData.objective && applicationData.objective.html ? applicationData.objective.html : "" }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : null}
        <div className={styles.PreviewSectionSubHead}>Linked Documents &amp; Work Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td><span className={styles.PreviewLabel}>Linked SWMS</span><span className={styles.PreviewValue}>{displayValue(projectDetails.swms_number || context.swmsNumber)}</span></td>
              <td><span className={styles.PreviewLabel}>SWMS Name</span><span className={styles.PreviewValue}>{displayValue(projectDetails.swms_name)}</span></td>
              <td colSpan={2}><span className={styles.PreviewLabel}>Linked Emergency Plan</span><span className={styles.PreviewValue}>{displayValue(linkedPlans)}</span></td>
            </tr>
            <tr>
              <td><span className={styles.PreviewLabel}>Site Name</span><span className={styles.PreviewValue}>{displayValue(projectDetails.site_name)}</span></td>
              <td colSpan={3}><span className={styles.PreviewLabel}>Site Address</span><span className={styles.PreviewValue}>{displayValue(projectDetails.site_address)}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
